import { useEffect } from 'react';
import { matchPath, useLocation, useNavigationType } from 'react-router-dom';

const scrollToTopExclusions = ['/properties'];

export const InitialScrollToTop = () => {
  const navigationType = useNavigationType();
  const location = useLocation();

  useEffect(() => {
    if (
      navigationType === 'POP' &&
      scrollToTopExclusions.some((exclusion) =>
        matchPath(location.pathname, exclusion),
      )
    ) {
      return;
    }
    setTimeout(() => {
      window.scrollTo(0, 0);
    });
  }, [location, navigationType]);

  return null;
};
